<!--
 * @Description: 部门账号 查看弹出层
 * @Author: ma.cq
 * @Date: 2020-03-31 10:28:41
 * @LastEditors: sunluhua 1057254519@qq.com
 * @LastEditTime: 2022-11-07 08:02:21
 -->
<template>
  <el-dialog
    title="查看"
    :visible.sync="visiable"
    width="800px"
    @close="handleClose">
    <el-form label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="主账号用户名">
            {{this.info.rootAccount}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册手机号">
            {{this.info.phone}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主账号客户名称">
            {{this.info.customer}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="子账号类型">部门账号</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="子账号手机">
            {{this.info.childPhone}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="子账户用户名">
            {{this.info.username}}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限分配">
            {{powerListStr}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="添加人">
            {{this.info.createPerson}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="添加时间">
            {{this.info.createTime}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="授权状态">
            {{this.info.innerAuthorize === 1 ? '未授权' : '已授权'}}
            <el-button type="primary" @click="handleAuthorize">{{this.info.innerAuthorize === 1 ? '授权' : '取消授权'}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'checkDialog',
  props: ['show', 'info'],
  data () {
    return {
      visiable: false
    }
  },
  computed: {
    powerListStr () {
      if (!this.info.power) {
        return ''
      }
      const map = {
        1: '查看产品',
        2: '查看协议',
        3: '制作订单',
        4: '查看订单',
        5: '付款',
        6: '价格隐藏'
      }
      const list = this.info.power.map(item => {
        return map[item]
      })
      return list.join('，')
    }
  },
  methods: {
    ...mapActions(['authorAccount']),
    handleAuthorize () {
      this.$parent.handleAuthorize(this.info)
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visiable = newVal
    }
  }
}
</script>
